//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var myconfig = require('./someConfig');
import VueElementLoading from 'vue-element-loading'
export default {
  name: 'App',
  components: {
    VueElementLoading
  },
  beforeMount:function(){
  },
  methods:{
  clickTree(node){
    console.log(node);
    this.$set(this,'leftDrawerOpen',true);
    if(node!=null&&node.search(/\d+/g)>-1&&node.search(/年印贈之乾隆大藏經/)>-1){
      this.$set(this,'leftDrawerOpen',true);
    }else if(node!=null&&node.search(/\d+/g)>-1&&node.search(/冊/)>-1){
      let booknum = node.match(/\d+/g);
      this.$set(this,'leftDrawerOpen',true);
      this.$set(this,'booknum',booknum[0]);
    }else if(node!=null){
      this.$set(this,'isActive',true);
      this.$http.post(myconfig.service.findRollNum,{scripttruetitle:node,booknum:this.booknum,datastatus:2}).then(res=>{
        console.log(res.data)
        let title='';
        let booknum='';
        let pagelist = res.data.data;
        let treeList=[];
        let scriptList=[];
        pagelist.forEach((item)=>{
          let scripttruetitle = item.scripttruetitle;
          booknum=item.booknum;
          if(scripttruetitle==title){
            treeList.push({label:'第'+item.booknum+'冊 第'+item.rollnum+'卷',value: '第'+item.rollnum+'卷',scripttruetitle:item.scripttruetitle});
          }else{
            treeList.push({label:'第'+item.booknum+'冊 第'+item.rollnum+'卷',value: '第'+item.rollnum+'卷',scripttruetitle:item.scripttruetitle});
            scriptList.push(treeList);
          }
          title=item.scripttruetitle;
        });
        this.$set(this,'rollItems',treeList);
        this.$set(this,'items',null);
        this.$set(this,'booknum',booknum);
        this.$set(this,'scipttitle',title);
        this.$set(this,'leftDrawerOpen',false);
        this.$set(this,'scriptList',scriptList);
        this.$set(this,'isActive',false);
      },res=>{
        console.log(res)
        this.$set(this,'isActive',false);
      }).catch(e=>{console.error(e)})
    }


  },
    clickbadge(e,v){
      console.log(e);
      console.log(v);
      this.$set(this,"isActive",true);
      //let rollnum = node.label;
      this.$http.post(myconfig.service.findDetail,{rollnum:e,datastatus:2,scripttruetitle:v}).then(res=>{
        console.log(res.data)
        let pagelist = res.data.data;
        this.$set(this,'items',pagelist);
        this.$set(this,'isActive',false);
        this.$el.querySelector(`#qList`).scrollIntoView({
          behavior: "smooth",  // 平滑过渡
          block:    "start"  // 上边框与视窗顶部平齐。默认值
        });
      },res=>{
        this.$set(this,'isActive',false);
        console.log(res)
      }).catch(e=>{console.error(e);this.$set(this,'isActive',false);})

    },
    onLazyLoad ({key, done }){
    if(key.search(/年印贈之乾隆大藏經/)>-1){
      this.$set(this,'isActive',true);
      this.$http.post(myconfig.service.findBookNum,{datastatus:2}).then(res=>{
        console.log(res.data)
        let pagelist = res.data.data;
        let treeList=[];
        pagelist.forEach((item)=>{
          treeList.push({label:'第'+item.booknum+'冊',lazy:true});
        });
        done(treeList);
        this.$set(this,'isActive',false);
      },res=>{
        console.log(res)
        this.$set(this,'isActive',false);
      }).catch(e=>{console.error(e)})
    }
    else if(key.search(/\d+/g)>-1&&key.search(/冊/)>-1){
      this.$set(this,'isActive',true);
      let booknum = key.match(/\d+/g);
      this.$set(this,'booknum',booknum[0]);
      this.$http.post(myconfig.service.findScripttrueTitle,{booknum:booknum[0],datastatus:2}).then(res=>{
        console.log(res.data)
        let pagelist = res.data.data;
        let treeList=[];
        pagelist.forEach((item)=>{
          treeList.push({label:item.scripttruetitle});
        });
        done(treeList);
        this.$set(this,'rollItems',[]);
        this.$set(this,'scipttitle',null);
        this.$set(this,'isActive',false);
      },res=>{
        console.log(res)
        this.$set(this,'isActive',false);
      }).catch(e=>{console.error(e)})
    }
  },
    searchScript(){
      this.$set(this,'isActive',true);
      this.$http.post(myconfig.service.findRollNum,{scripttruetitle:this.text,datastatus:2}).then(res=>{
        console.log(res.data)
        let title='';
        let pagelist = res.data.data;
        let treeList=[];
        let scriptList=[];
        let booknum='';
        pagelist.forEach((item)=>{
          let scripttruetitle = item.scripttruetitle;
          booknum=item.booknum;
          if(title==''){
            treeList.push({label:'第'+item.booknum+'冊 第'+item.rollnum+'卷',value: '第'+item.rollnum+'卷',scripttruetitle:item.scripttruetitle});
          }else if(scripttruetitle==title){
            treeList.push({label:'第'+item.booknum+'冊 第'+item.rollnum+'卷',value: '第'+item.rollnum+'卷',scripttruetitle:item.scripttruetitle});
          }else{
            scriptList.push(treeList);
            treeList=[]
            treeList.push({label:'第'+item.booknum+'冊 第'+item.rollnum+'卷',value: '第'+item.rollnum+'卷',scripttruetitle:item.scripttruetitle});
          }
          title=item.scripttruetitle;
        });
        scriptList.push(treeList);
        this.$set(this,'rollItems',treeList);
        this.$set(this,'items',null);
        this.$set(this,'scriptList',scriptList);
        this.$set(this,'booknum',booknum);
        this.$set(this,'scipttitle',title);
        this.$set(this,'isActive',false);
      },res=>{
        console.log(res)
        this.$set(this,'isActive',false);
      }).catch(e=>{console.error(e)})

    }
},
  data () {
    return {
      isActive:false,
      leftDrawerOpen:false,
      items:[],
      scriptList:[],
      rollItems:[],
      text:'',
      booknum:'',
      scipttitle:'',
      selected:null,
      requestMessae:'',
      showing:false,
      splitterModel: 30,
      simple: [
        {label:'2009~2011年印贈之乾隆大藏經（詳情冊數請點 ▶）',
          lazy:true
        }
      ]
    }
  }
}
